import { render, staticRenderFns } from "./AdminSchedulesBatchModalChangeLocation.vue?vue&type=template&id=5ba1c962&scoped=true"
import script from "./AdminSchedulesBatchModalChangeLocation.vue?vue&type=script&lang=js"
export * from "./AdminSchedulesBatchModalChangeLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba1c962",
  null
  
)

export default component.exports